// extracted by mini-css-extract-plugin
export default {"error":"Loading_error__VDpid","loadingGif":"Loading_loadingGif__DiwdP"};